import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Navbar from "../Components/Navbar/navbar";

export default function RelatorioDosagem() {
  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper sx={{ p: 3, borderRadius: "8px", boxShadow: "none", border: "1px solid #e2e8f0" }}>
          <Typography variant="h6" fontWeight={700}>Relatório de Dosagem</Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            Tela reservada para o relatório de dosagem.
          </Typography>
        </Paper>
      </Box>
    </>
  );
}
